module.exports = __webpack_public_path__ + "static/media/11.9f89bda2.jpg";